<template>
  <App :session="session">

    <i class="load" v-if="loading"></i>

    <div v-if="!loading">
      <div class="tools-head">
        <h2 class="tools-title">Herramientas</h2>
        <p class="tools-subtitle">Recursos útiles para tu negocio</p>
      </div>

      <div class="tools-grid">
        <a
          class="tool-card"
          v-for="t in items"
          :key="t.id"
          :href="t.link"
          target="_blank"
          rel="noreferrer"
        >
          <div class="tool-left">
            <div class="tool-img" v-if="t.img">
              <img :src="t.img" :alt="t.title" />
            </div>
            <div class="tool-text">
              <h3 class="tool-title">{{ t.title }}</h3>
              <p class="tool-desc">{{ t.description }}</p>
            </div>
          </div>

          <div class="tool-action">
            <span class="tool-btn">Ver</span>
          </div>
        </a>
      </div>

      <div v-if="items.length === 0" class="tools-empty">
        No hay herramientas configuradas aún.
      </div>

      <div class="tools-social-row">
        <component
          :is="socialTrimmed.facebook ? 'a' : 'span'"
          class="tool-social"
          :class="{ 'tool-social--inactive': !socialTrimmed.facebook }"
          v-bind="facebookBind"
        >
          <div class="tool-social-circle">
            <svg class="tool-social-icon" viewBox="0 0 24 24" aria-hidden="true">
              <path
                fill="currentColor"
                d="M13.397 20.997v-8.196h2.765l.411-3.209h-3.176V7.548c0-.926.258-1.56 1.587-1.56h1.684V3.127A22.336 22.336 0 0014.201 3c-2.444 0-4.122 1.492-4.122 4.231v2.355H7.332v3.209h2.753v8.202h3.312z"
              />
            </svg>
          </div>
          <span class="tool-social-label">Facebook</span>
        </component>
        <component
          :is="socialTrimmed.tiktok ? 'a' : 'span'"
          class="tool-social"
          :class="{ 'tool-social--inactive': !socialTrimmed.tiktok }"
          v-bind="tiktokBind"
        >
          <div class="tool-social-circle">
            <svg class="tool-social-icon tool-social-icon--tiktok" viewBox="0 0 24 24" aria-hidden="true">
              <path
                fill="currentColor"
                d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005 20.1a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1-.1z"
              />
            </svg>
          </div>
          <span class="tool-social-label">TikTok</span>
        </component>
      </div>

    </div>
  </App>
</template>

<script>
import App from '@/views/layouts/App'
import api from '@/api'

export default {
  components: {
    App,
  },
  data() {
    return {
      items: [],
      loading: true,
      socialLinks: {
        facebookLink: '',
        tiktokLink: '',
      },
    }
  },
  computed: {
    session() { return this.$store.state.session },
    socialTrimmed() {
      const fb = this.ensureHttpUrl(this.socialLinks.facebookLink)
      const tt = this.ensureHttpUrl(this.socialLinks.tiktokLink)
      return { facebook: fb, tiktok: tt }
    },
    facebookBind() {
      const href = this.socialTrimmed.facebook
      if (href) {
        return {
          href,
          target: '_blank',
          rel: 'noreferrer noopener',
          'aria-label': 'Abrir Facebook',
        }
      }
      return {
        role: 'img',
        'aria-label': 'Facebook',
      }
    },
    tiktokBind() {
      const href = this.socialTrimmed.tiktok
      if (href) {
        return {
          href,
          target: '_blank',
          rel: 'noreferrer noopener',
          'aria-label': 'Abrir TikTok',
        }
      }
      return {
        role: 'img',
        'aria-label': 'TikTok',
      }
    },
  },
  methods: {
    ensureHttpUrl(s) {
      const t = (s || '').trim()
      if (!t) return ''
      if (/^https?:\/\//i.test(t)) return t
      if (/^\/\//.test(t)) return 'https:' + t
      return 'https://' + t.replace(/^\/+/, '')
    },
  },
  async created() {
    // GET data
    const { data } = await api.tools(this.session)

    this.loading = false

    // error
    if(data.error && data.msg == 'invalid session') this.$router.push('/login')
    if(data.error && data.msg == 'unverified user') this.$router.push('/verify')

    // success
    const s = data.socialLinks || {}
    this.socialLinks = {
      facebookLink: typeof s.facebookLink === 'string' ? s.facebookLink : '',
      tiktokLink: typeof s.tiktokLink === 'string' ? s.tiktokLink : '',
    }
    this.items = (data.tools || []).filter((t) => t && t.active !== false)
    this.$store.commit('SET_NAME', data.name)
    this.$store.commit('SET_LAST_NAME',  data.lastName)
    this.$store.commit('SET_AFFILIATED', data.affiliated)
    this.$store.commit('SET_ACTIVATED',  data.activated)
    this.$store.commit('SET__ACTIVATED',  data._activated)
    this.$store.commit('SET_PLAN',       data.plan)
    this.$store.commit('SET_COUNTRY',    data.country)
    this.$store.commit('SET_PHOTO',      data.photo)
    this.$store.commit('SET_TREE',       data.tree)
  },
};
</script>

<style lang="stylus">
  @import "~@/assets/style/vars.styl"

  .tools-head
    margin 14px 0 22px
    max-width 1200px
    margin-left auto
    margin-right auto

  .tools-title
    font-size 30px
    font-weight 700
    color #000
    margin 0

  .tools-subtitle
    font-size 16px
    color #666
    margin 8px 0 0

  .tools-social-row
    display flex
    flex-wrap wrap
    justify-content flex-start
    gap 28px 36px
    margin 32px auto 24px
    max-width 1200px
    padding 0 14px

  .tool-social
    display flex
    flex-direction column
    align-items center
    text-decoration none
    color #1a1a1a
    min-width 88px

  .tool-social--inactive
    cursor default
    pointer-events none

  .tool-social-circle
    width 76px
    height 76px
    border-radius 50%
    background #000
    display flex
    align-items center
    justify-content center
    box-shadow 0 6px 18px rgba(0, 0, 0, 0.18)
    transition transform 0.15s ease, box-shadow 0.15s ease

  .tool-social:hover .tool-social-circle
    transform translateY(-2px)
    box-shadow 0 10px 24px rgba(0, 0, 0, 0.22)

  .tool-social-icon
    width 38px
    height 38px
    color c-main-golden

  .tool-social-icon--tiktok
    width 34px
    height 34px

  .tool-social-label
    margin-top 10px
    font-size 15px
    font-weight 600
    letter-spacing 0.01em

  @media (max-width: m-break)
    .tools-social-row
      margin-top 26px
      margin-bottom 16px
      gap 22px 28px

    .tool-social-circle
      width 68px
      height 68px

    .tool-social-icon
      width 34px
      height 34px

    .tool-social-icon--tiktok
      width 30px
      height 30px

    .tool-social-label
      font-size 14px
      margin-top 8px

  .tools-grid
    display grid
    grid-template-columns 1fr
    row-gap 20px

  @media (min-width: d-break)
    .tools-grid
      grid-template-columns 1fr 1fr
      column-gap 26px
      row-gap 26px
      max-width 1200px
      margin 0 auto

  .tool-card
    background white
    border-radius 12px
    padding 22px 22px
    display flex
    align-items center
    justify-content space-between
    text-decoration none
    color inherit
    box-shadow 0px 14px 28px rgba(0,0,0,.08)
    border 1px solid rgba(0,0,0,.05)
    transition transform .15s ease, box-shadow .15s ease, border-color .15s ease

    &:hover
      transform translateY(-2px)
      box-shadow 0px 18px 36px rgba(0,0,0,.10)
      border-color rgba(0,0,0,.08)

  .tool-left
    display flex
    align-items center
    min-width 0

  .tool-img
    width 84px
    height 84px
    border-radius 16px
    overflow hidden
    border 1px solid rgba(0,0,0,.06)
    background c-ligh-gray
    flex 0 0 auto
    img
      width 100%
      height 100%
      object-fit cover

  .tool-text
    margin-left 16px
    min-width 0

  .tool-title
    font-size 18px
    font-weight 700
    color #000
    margin 0

  .tool-desc
    font-size 14px
    color #666
    margin 8px 0 0
    line-height 1.3
    display -webkit-box
    -webkit-line-clamp 2
    -webkit-box-orient vertical
    overflow hidden

  .tool-action
    margin-left 16px
    flex 0 0 auto

  .tool-btn
    background c-main-red
    color white
    font-size 14px
    font-weight 700
    padding 8px 24px
    border-radius 6px
    min-width 64px
    text-align center

  // mobile overrides (must be after base styles)
  @media (max-width: m-break)
    .tools-head
      margin 10px 0 14px
      padding 0 14px

    .tools-title
      font-size 28px

    .tools-subtitle
      font-size 16px
      margin 4px 0 0

    .tools-grid
      row-gap 20px
      padding 0 14px

    .tool-card
      padding 14px 14px

    .tool-img
      width 56px
      height 56px
      border-radius 12px

    .tool-text
      margin-left 12px

    .tool-title
      font-size 16px

    .tool-desc
      font-size 13px
      margin 6px 0 0
      display block
      -webkit-line-clamp initial
      -webkit-box-orient initial
      overflow visible
      white-space normal

    .tool-action
      margin-left 12px

    .tool-btn
      font-size 12px
      padding 5px 12px
      border-radius 6px
      min-width 48px

  .tools-empty
    margin-top 18px
    padding 28px 16px
    max-width 1200px
    margin-left auto
    margin-right auto
    text-align center
    color #666
    font-size 14px

  @media (max-width: m-break)
    .tools-empty
      padding 22px 14px
      font-size 13px
</style>